export function useChangeSelectedRecursively(items, newState) {
	return items.map(c => {
		c.selected = newState

		if (c.children?.length) {
			c.children = useChangeSelectedRecursively(c.children, newState)
		}

		return c
	})
}
